"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _Event = _interopRequireDefault(require("MeetingsLib/models/Event"));

var _default = (0, _immutable.Record)({
  event: new _Event.default(),
  postResponse: null
}, 'BookingLifecycleRecord');

exports.default = _default;
module.exports = exports.default;